/** Stable id required so react-bootstrap can wire the Tooltip via aria-describedby. */
export const SAVE_STATUS_TOOLTIP_ID = 'email-maker-save-status-tooltip';

export const SAVE_STATUS_TOOLTIP_SHOW_DELAY_MS = 50;

export const SAVE_STATUS_TOOLTIP_HIDE_DELAY_MS = 100;

export enum SaveStatusBadgeVariant {
  DEFAULT = 'default',
  DISABLED = 'disabled',
  SAVING = 'saving',
}

export interface SaveStatusBadgeProps {
  label: string;
  icon: string;
  /** When undefined the badge renders with no tooltip wrapper. */
  tooltipText?: string;
  variant?: SaveStatusBadgeVariant;
}
